import { useEffect, useState } from "react";
import { Toast } from "../components/Animations";

export default function FormStatus({formStatus='', customClass=''}) {
    const [animateStatus, setAnimateStatus] = useState(false);
    const [formMessage, setFormMessage] = useState('');

    useEffect(() => {
        showFormStatus();
        if ( formStatus ) {
            setFormMessage(formStatus);
        }
    }, [formStatus]);

    const playStatusAnimation = () => {
        setAnimateStatus(true);
        setTimeout( () => {
            setAnimateStatus(false);
        }, 500);
    }

    const showFormStatus = () => {
        playStatusAnimation();
    }

    return (
        <Toast replay={animateStatus} customClass={`form-status ${customClass}`}>
            <p className="form-status__message">
                { formMessage }
            </p>
        </Toast>
    )
}